import { AttachedFile } from 'types/chat';

export const formatFile = (
  file: File,
): Promise<
  Omit<AttachedFile, 'fileName'> & {
    filename: AttachedFile['fileName'];
  }
> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      const result = reader.result;
      if (typeof result !== 'string') {
        reject({
          filename: file.name,
          mimeType: file.type,
          contentBase64: '',
        });
        return;
      }

      const [, contentBase64] = result.split(',');

      resolve({
        filename: file.name,
        mimeType: file.type,
        contentBase64,
      });
    };

    reader.onerror = () => {
      reject({
        filename: file.name,
        mimeType: file.type,
        contentBase64: '',
      });
    };
  });
